/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type TipoOlioLavorazioni =
  (typeof TipoOlioLavorazioni)[keyof typeof TipoOlioLavorazioni];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TipoOlioLavorazioni = {
  olioIntero: "olioIntero",
  lubrorefrigerante: "lubrorefrigerante",
} as const;
